import { Person, IPerson } from '@/classes/InjuryForm/Person';
import Employee from './Employee';

interface ISupervisorReport {
    willfulMisconduct?: boolean;
    willfulMisconductStatement?: string;
    thirdPartyCaused?: boolean;
    thirdParty?: Person;
    knowledgeAgree?: boolean;
    knowledgeAgreeStatement?: string;
    onsiteTreated?: string;
    onsiteTreatment?: string;
    offsiteTreated?: string;
    offsiteTreatment?: string;
    supervisorWitness?: boolean;
    supervisorLocation?: string;
    studentSupervised?: boolean;
    supervisor?: Person;
}

class SupervisorReport implements ISupervisorReport {
    public willfulMisconduct?: boolean;
    public willfulMisconductStatement?: string;
    public thirdPartyCaused?: boolean;
    public thirdParty?: Person;
    public knowledgeAgree?: boolean;
    public knowledgeAgreeStatement?: string;
    public onsiteTreated?: string;
    public onsiteTreatment?: string;
    public offsiteTreated?: string;
    public offsiteTreatment?: string;
    public supervisorWitness?: boolean;
    public supervisorLocation?: string;
    public studentSupervised?: boolean;
    public supervisor?: Person;

    constructor(sr: ISupervisorReport = {}) {
        this.willfulMisconduct = sr.willfulMisconduct;
        this.willfulMisconductStatement = sr.willfulMisconductStatement;
        this.thirdPartyCaused = sr.thirdPartyCaused;
        this.thirdParty = new Person(sr.thirdParty);
        this.knowledgeAgree = sr.knowledgeAgree;
        this.knowledgeAgreeStatement = sr.knowledgeAgreeStatement;
        this.onsiteTreated = sr.onsiteTreated;
        this.onsiteTreatment = sr.onsiteTreatment;
        this.offsiteTreated = sr.offsiteTreated;
        this.offsiteTreatment = sr.offsiteTreatment;
        this.supervisorWitness = sr.supervisorWitness;
        this.studentSupervised = sr.studentSupervised;
        this.studentSupervised = sr.studentSupervised;
        this.supervisorLocation = sr.supervisorLocation;
        this.supervisor = new Person(sr.supervisor);
    }

    public isSupervisorTabValid(employee: Employee | undefined): string[] {
        let validations: string[] = [];
        if (this.willfulMisconduct === undefined) {
            validations.push('willfulMisconduct');
        }
        if (this.willfulMisconduct) {
            if (this.willfulMisconductStatement === undefined || this.willfulMisconductStatement.length === 0) {
                validations.push('willfulMisconductStatement');
            }
        }
        if (this.thirdPartyCaused === undefined) {
            validations.push('thirdPartyCaused');
        }
        if (this.thirdPartyCaused) {
            if (this.thirdParty === undefined) {
                validations.push('thirdParty');
            } else {
                if (this.thirdParty.firstName === undefined || this.thirdParty.firstName.length === 0) {
                    validations.push('firstName');
                }
                if (this.thirdParty.lastName === undefined || this.thirdParty.lastName.length === 0) {
                    validations.push('lastName');
                }
                if (this.thirdParty.title === undefined || this.thirdParty.title.length === 0) {
                    validations.push('title');
                }
            }
        }
        if (employee === undefined) {
            if (this.studentSupervised === undefined) {
                validations.push('studentSupervised');
            }
        } else {
            validations = validations.concat(employee.isSupervisorTabValid());
        }
        if (this.knowledgeAgree === undefined) {
            validations.push('knowledgeAgree');
        }
        if (this.knowledgeAgree === false) {
            if (this.knowledgeAgreeStatement === undefined || this.knowledgeAgreeStatement.length === 0) {
                validations.push('knowledgeAgreeStatement');
            }
        }
        if (this.onsiteTreated === undefined) {
            validations.push('onsiteTreated');
        }
        if (this.onsiteTreated === 'true') {
            if (this.onsiteTreatment === undefined || this.onsiteTreatment.length === 0) {
                validations.push('onsiteTreatment');
            }
        }
        if (this.offsiteTreated === undefined) {
            validations.push('offsiteTreated');
        }
        if (this.offsiteTreated === 'true') {
            if (this.offsiteTreatment === undefined || this.offsiteTreatment.length === 0) {
                validations.push('offsiteTreatment');
            }
            if (employee !== undefined) {
                if (employee.offsiteTreatment) {
                    validations = validations.concat(employee.offsiteTreatment.isValid());
                } else {
                    validations.push('offsiteTreatment');
                }
            }
        }
        if (this.supervisor === undefined) {
            validations.push('supervisor');
        } else {
            if (this.supervisor.firstName === undefined || this.supervisor.firstName.length === 0 ) {
                validations.push('firstName');
            }
            if (this.supervisor.lastName === undefined || this.supervisor.lastName.length === 0 ) {
                validations.push('lastName');
            }
            if (this.supervisor.title === undefined || this.supervisor.title.length === 0 ) {
                validations.push('title');
            }
            if (this.supervisor.officePhone === undefined || this.supervisor.officePhone.length < 13 ) {
                validations.push('officePhone');
            }
        }
        if (this.supervisorWitness === undefined) {
            validations.push('supervisorWitness');
        } else if (this.supervisorWitness === false) {
            if (this.supervisorLocation === undefined || this.supervisorLocation.length === 0) {
                validations.push('supervisorLocation');
            }
        }
        return validations;
    }
}

export default SupervisorReport;
export { SupervisorReport, ISupervisorReport };
